// Franjas horarias de trabajo (20-oct-2026): las mismas en TODA la app — la agenda del Panel, agendar
// un trabajo o un pedido, reprogramar, los días ocupados del técnico y los días/horarios que marca
// la empresa. Jornada de 8 a 16. Antes había tres esquemas que no coincidían (mañana/tarde de la
// agenda, 4 franjas de 8 a 20 del portal y mañana/tarde/día de los ocupados).
// El id es el rango ("08:00-10:00"): es lo que se guarda como hora de la visita y como franja de
// las ventanas y de los ocupados (el backend ya acepta rangos).

export const FRANJAS = [
    { id: '08:00-10:00', corto: '8 a 10',  rango: '8 a 10',  desde: 8 * 60,  hasta: 10 * 60 },
    { id: '10:00-12:00', corto: '10 a 12', rango: '10 a 12', desde: 10 * 60, hasta: 12 * 60 },
    { id: '12:00-14:00', corto: '12 a 14', rango: '12 a 14', desde: 12 * 60, hasta: 14 * 60 },
    { id: '14:00-16:00', corto: '14 a 16', rango: '14 a 16', desde: 14 * 60, hasta: 16 * 60 },
];
export const INICIO_JORNADA = '08:00';
export const FIN_JORNADA = '16:00';
const FIN_MIN = 16 * 60;

export const aMin = (h) => { const [hh, mm] = String(h).split(':').map(Number); return hh * 60 + (mm || 0); };
const RANGO = /^(\d{1,2}:\d{2})\s*-\s*(\d{1,2}:\d{2})$/;
const HORA = /^(\d{1,2}):(\d{2})/;

// Franjas viejas (ventanas del portal hasta el 20-oct-2026) → las nuevas que cubren
const VIEJAS = {
    '08:00-12:00': ['08:00-10:00', '10:00-12:00'],
    '14:00-18:00': ['14:00-16:00'],
    '18:00-20:00': [],
};

/** Rango [desde, hasta] en minutos de cualquier texto de horario, o null. */
export function rangoDe(texto) {
    const t = String(texto || '').trim();
    const r = RANGO.exec(t);
    if (r) return [aMin(r[1]), aMin(r[2])];
    const h = HORA.exec(t);
    if (h) { const m = aMin(`${h[1]}:${h[2]}`); return [m, m + 1]; }
    // Textos viejos de la agenda y de los ocupados
    if (/^(mañana|manana)$/i.test(t)) return [8 * 60, 13 * 60];
    if (/^tarde$/i.test(t)) return [13 * 60, 20 * 60];
    if (/^(dia|día|todo el d[ií]a)$/i.test(t)) return [0, 24 * 60];
    return null;
}

/** Franja (id) donde cae la hora de una visita ("09:30", "09:00-10:00", "Mañana"…). Fuera de 8 a 16 → null. */
export function franjaDe(hora) {
    const r = rangoDe(hora);
    if (!r) return null;
    const ini = /^(mañana|manana)$/i.test(String(hora).trim()) ? 8 * 60 : /^tarde$/i.test(String(hora).trim()) ? 14 * 60 : r[0];
    return FRANJAS.find(f => ini >= f.desde && ini < f.hasta)?.id || null;
}

/** Franja en la que va una visita en la agenda (28-oct-2026): la de su horario; si no tenía horario
 * (o uno fuera de las franjas) y ya se hizo, la de la hora en que se cerró. Antes del inicio va en la
 * primera franja y después del fin en la última: así lo hecho queda en el día y no en "Sin hora". */
export function franjaDeVisita(o) {
    const propia = franjaDe(o?.horaEstimada);
    if (propia) return propia;
    if (o?.estado !== 'COMPLETADA' || !o?.fechaCompletada) return null;
    const m = /T?(\d{2}):(\d{2})/.exec(String(o.fechaCompletada).replace(' ', 'T').slice(10));
    if (!m) return null;
    const min = Number(m[1]) * 60 + Number(m[2]);
    if (min < FRANJAS[0].desde) return FRANJAS[0].id;
    if (min >= FRANJAS[FRANJAS.length - 1].hasta) return FRANJAS[FRANJAS.length - 1].id;
    return FRANJAS.find(f => min >= f.desde && min < f.hasta)?.id || null;
}

/** ¿Un horario (rango, hora, MANANA/TARDE/DIA) se pisa con la franja? */
export function pisaFranja(texto, franjaId) {
    const f = FRANJAS.find(x => x.id === franjaId);
    const r = rangoDe(texto);
    return !!(f && r && r[0] < f.hasta && r[1] > f.desde);
}

/** "8 a 10" (o el texto del horario si no es una franja). */
export function etiquetaFranja(id) {
    return FRANJAS.find(f => f.id === id)?.corto || String(id || '');
}

/** Ventanas con franjas viejas → las nuevas (sin repetir). Las de horario fijo recalculan su franja. */
export function normalizarVentanas(lista) {
    const out = [];
    const ya = new Set();
    (lista || []).forEach(v => {
        if (!v) return;
        const franjas = v.hora ? [franjaDe(v.hora)].filter(Boolean)
            : VIEJAS[v.franja] || (FRANJAS.some(f => f.id === v.franja) ? [v.franja] : []);
        franjas.forEach(fr => {
            const k = `${v.dia}|${fr}|${v.hora || ''}`;
            if (ya.has(k)) return;
            ya.add(k);
            out.push(v.hora ? { ...v, franja: fr } : { dia: v.dia, franja: fr });
        });
    });
    return out;
}

/** ¿Hay en la lista alguna ventana vieja que quedó fuera de la jornada (18 a 20)? */
export const tieneFueraDeHorario = (lista) => (lista || []).some(v => v && (v.franja === '18:00-20:00' || (v.hora && !franjaDe(v.hora))));

/** La primera franja de hoy que todavía no terminó, o null. */
export function proximaFranjaHoy() {
    const d = new Date();
    const ahora = d.getHours() * 60 + d.getMinutes();
    return FRANJAS.find(f => f.hasta > ahora)?.id || null;
}
export const jornadaTerminada = () => { const d = new Date(); return d.getHours() * 60 + d.getMinutes() >= FIN_MIN; };
